import { TValidator } from './types';

export const NOT_ONLY_WHITE_CHARACTERS_KEY = 'validation.notOnlyWhiteCharacters';

export const isNotOnlyWhiteCharacters: TValidator = (value) => {
  if (!value.replace(/\s/g, '').length) {
    return NOT_ONLY_WHITE_CHARACTERS_KEY;
  }

  return undefined;
};
